var map = {
	"./Edit.svg": 2540,
	"./EditChecked.svg": 7263,
	"./UseNew.svg": 9753,
	"./UseNewChecked.svg": 1412,
	"./UsePrevious.svg": 8202,
	"./UsePreviousChecked.svg": 3293,
	"./UseTemplate.svg": 291,
	"./UseTemplateChecked.svg": 6806,
	"./oneClick.icon.png": 7473,
	"./projectAuthorisation.project.icon.png": 2117,
	"./safari-pinned-tab.svg": 4569
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2704;